import React, { useCallback } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import ThemeToggle from './ThemeToggle';
import LanguageToggle from './LanguageToggle';
import './TopPanel.css';

const TopPanel = React.memo(({
  user = null,
  onLogout = null,
  showNavigation = false,
  showUserInfo = false,
  className = ''
}) => {
  // Stable event handler to prevent unnecessary re-renders
  const handleLogout = useCallback(async () => {
    if (onLogout) {
      await onLogout();
    }
  }, [onLogout]);

  return (
    <div
      className={`top-panel ${className}`}
      role="banner"
    >
      {/* Left side - Navigation (only when authenticated and showNavigation is true) */}
      {user && showNavigation ? (
        <div className="top-panel-left">
          <nav className="top-panel-nav">
            <Link
              to="/"
              className="nav-link"
            >
              Exercises
            </Link>
            <Link
              to="/leaderboard"
              className="nav-link"
            >
              Leaderboard
            </Link>
            {user.is_admin && (
              <Link
                to="/admin"
                className="nav-link"
              >
                Admin Panel
              </Link>
            )}
          </nav>
        </div>
      ) : (
        <div className="top-panel-spacer"></div>
      )}

      {/* Right side - User info and controls */}
      <div className="top-panel-right">
        {/* User info (only when authenticated and showUserInfo is true) */}
        {user && showUserInfo && (
          <span className="user-email">{user.email}</span>
        )}

        {/* Logout button (only when authenticated and onLogout is provided) */}
        {user && onLogout && (
          <button
            onClick={handleLogout}
            className="logout-button"
          >
            Logout
          </button>
        )}

        {/* Language and Theme toggles (always present) */}
        <LanguageToggle />
        <ThemeToggle />
      </div>
    </div>
  );
});

// Display name for React DevTools
TopPanel.displayName = 'TopPanel';

// PropTypes validation
TopPanel.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    is_admin: PropTypes.bool.isRequired
  }),
  onLogout: PropTypes.func,
  showNavigation: PropTypes.bool,
  showUserInfo: PropTypes.bool,
  className: PropTypes.string
};

// Note: Default props are already handled by destructuring with default values in the function signature

export default TopPanel;